<div nz-row [ngClass]="{'product-item': isProductType()}">
  <div nz-col [nzSpan]="isProductType() ? 15:19" class="item-name-column">
        <div class="item-name">
          <h5>{{ cartItem.item.name }}</h5>
        </div>
        <nz-button-group *ngIf="(detailed && !isPrepServiceItem(cartItem)) || (!readonly && deletable) ">
          <button
            id="more-information-button"
            nz-button
            nzType="link"
            *ngIf="detailed && !isPrepServiceItem(cartItem)"
            (click)="toProductPage()">
            More Information
          </button>
          <button
            id="delete-cart-item-button"
            nz-button
            nzType="link"
            *ngIf="(!readonly && deletable)"
            (click)="deleteCartItem()">Delete</button>
        </nz-button-group>
  </div>
  <div nz-col [nzXs]="{span: 5, push: isProductType() ? 4:0}" class="item-price-column">
    <app-cart-item-price [cartItem]="cartItem"></app-cart-item-price>
  </div>
  <div nz-col [nzXs]="{span: 24, push: 0}" [nzLg]="{span: 4, pull: 4}" *ngIf="isProductType() && isSamplingSupplyItem(cartItem)">
    <app-quantity-input
      [(modelField)]="cartItem.quantity"
      id="CheckoutQuantity{{cartItem.item.name | replaceStr}}"
      [isCartItem]="true"
      [sampling]="cartSampling"
      [cartItem]="cartItem">
    </app-quantity-input>
  </div>
</div>